import {
  IMobilixApiClient,
  MobilixApiClient,
} from '@allbin/mobilix-api-client';
import { useMemo } from 'react';
import { useConfigStore } from '../store/config';
import { getValidToken } from '../auth/auth';
import { IS_MOCK_AUTH_MODE } from '../auth/mock';

export const useApiClient = (): IMobilixApiClient => {
  const { baseUrl } = useConfigStore();

  return useMemo(() => {
    // In msw/gallery modes the stub token never needs renewing and requests
    // are intercepted by MSW, so the client runs tokenless.
    const token = IS_MOCK_AUTH_MODE ? undefined : getValidToken;

    return MobilixApiClient({
      baseUrl,
      token,
    });
  }, [baseUrl]);
};

export const usePublicApiClient = (): IMobilixApiClient => {
  const { baseUrl } = useConfigStore();

  return useMemo(() => {
    return MobilixApiClient({
      baseUrl,
      token: undefined,
    });
  }, [baseUrl]);
};
